import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Fade, Grid, Stack, TextField, TextareaAutosize, Typography } from "@mui/material";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import { TypeAnimation } from "react-type-animation";
import { AppSingleton } from "../services/user_config";

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100vh",
          backgroundImage: 'url("/img/landing-page-elderly.png")',
          opacity: 0.5,
          // zIndex: -1,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></Box>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100vh",
          display: "flex",
          // flexDirection: "column",
          alignItems: "flex-end",
          // justifyContent: "space-around",
        }}
      >
        <Box
          sx={{
            width: "100%",
            position: "absolute",
            top: "10%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TypeAnimation
            sequence={["人工智能鏡子", 1000, "人工智能 Mirror", 1000, "A.I. Mirror", 1000, "A.I. 鏡子", 1000]}
            wrapper="span"
            speed={200}
            style={{
              color: "white",
              fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(48) : getAdaptivFontSize(96)),
              display: "inline-block",
            }}
            repeat={Infinity}
          />
          {/* <Typography sx={{ fontSize: 128 }}>人工智能鏡子</Typography> */}
          {/* <img src="/img/game-title.png" alt="歡樂健身夥伴" style={{ maxWidth: "100%", maxHeight: "20vh" }} /> */}
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: getAdaptivFontSize(window.screen.height < 569 ? 2 : 16),
            // backgroundColor: "red",
          }}
        >
          <Stack spacing={window.screen.height < 569 ? 2 : 4} flexDirection="column" sx={{ width: "60%" }}>
            <Fade
              in={true}
              style={{
                transitionDelay: "1000ms",
              }}
              {...{ timeout: 1000 }}
            >
              <Button
                variant="contained"
                sx={{ borderRadius: "24px", boxShadow: 15 }}
                onClick={() => {
                  // navigate(`${getRoute("pose-mirror")}/`);
                  navigate(`${getRoute("listing-page")}/`);
                }}
              >
                <Typography variant={`${window.screen.height < 569 ? "h5" : "h3"}`} sx={{ p: 1 }}>
                  馬上開始
                </Typography>
              </Button>
            </Fade>

            <Fade
              in={true}
              style={{
                transitionDelay: "1500ms",
              }}
              {...{ timeout: 1000 }}
            >
              <Button variant="contained" sx={{ borderRadius: "24px", boxShadow: 15 }}>
                <Typography variant={`${window.screen.height < 569 ? "h5" : "h3"}`} sx={{ p: 1 }}>
                  介紹
                </Typography>
              </Button>
            </Fade>

            <Fade
              in={true}
              style={{
                transitionDelay: "2000ms",
              }}
              {...{ timeout: 1000 }}
            >
              <Button
                variant="contained"
                sx={{
                  borderRadius: "24px",
                  boxShadow: 15,
                }}
                onClick={() => {
                  navigate(`${getRoute("setting")}/`);
                }}
              >
                <Typography variant={`${window.screen.height < 569 ? "h5" : "h3"}`} sx={{ p: 1 }}>
                  設定
                </Typography>
              </Button>
            </Fade>
          </Stack>
        </Box>
        <Box
          sx={{
            textAlign: "center",
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
          }}
        >
          <Typography variant="caption" color="primary">
            &copy; {new Date().getFullYear()} Reality Connect Technologoy. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const f = () => {};

export { LandingPage, f };
